import { ReactAppParams } from '../types/ReactAppParams';

/**
 * Načtení konfigu aplikace.
 */
export function useAppConfig(): ReactAppParams {
  return window.appConfig;
}
